/**
 * Which single upsell the minicart shows.
 *
 * Hand-written UPSELL_RULES win and keep their discount; otherwise the best
 * partner from assets/complement-map.json, at full price. ONE suggestion for
 * the whole cart - a four-line basket must not produce four upsells.
 *
 * Pure selection, no DOM, so tests can load the real file - see
 * tests/cart-complements.test.mjs.
 */
(function () {
  function ruleMatches(rule, skus) {
    for (var i = 0; i < skus.length; i++) {
      var sku = skus[i] || '';
      if (rule.triggerSku && sku === rule.triggerSku) return true;
      if (rule.triggerSkuPrefix && sku.indexOf(rule.triggerSkuPrefix) === 0) return true;
      if (rule.triggerSkuContains && sku.indexOf(rule.triggerSkuContains) !== -1) return true;
    }
    return false;
  }

  // isAvailable is an optional (handle) => boolean predicate. Defaulting to
  // "assume available" keeps pick() synchronous and testable - callers that
  // already know availability (the drawer, backed by its productCache) pass
  // a real predicate; callers that don't (existing tests) get the old
  // behaviour unchanged.
  function pick(cartHandles, map, rules, cartSkus, isAvailable) {
    var handles = cartHandles || [];
    var skus = cartSkus || [];
    var available = typeof isAvailable === 'function' ? isAvailable : function () { return true; };
    var inCart = {};
    for (var i = 0; i < handles.length; i++) inCart[handles[i]] = true;

    // 1. hand-written rules win, and keep their commercial terms - but an
    // out-of-stock (or 404'd) hand-written candidate must fall through
    // rather than dead-end the whole pick: with 52 map sources now feeding
    // this, a sold-out hand rule + a sold-out/in-cart fallback would
    // otherwise suppress a perfectly good map suggestion.
    for (var r = 0; r < (rules || []).length; r++) {
      var rule = rules[r];
      if (!ruleMatches(rule, skus)) continue;
      if (!inCart[rule.upsellHandle] && available(rule.upsellHandle)) {
        return { handle: rule.upsellHandle, rule: rule };
      }
      if (rule.fallbackHandle && !inCart[rule.fallbackHandle] && available(rule.fallbackHandle)) {
        return { handle: rule.fallbackHandle, rule: rule };
      }
    }

    // 2. otherwise the best mapped partner not already in the basket and
    //    actually available. Partner lists are pre-sorted by score, so the
    //    first available hit wins.
    for (var h = 0; h < handles.length; h++) {
      var partners = (map || {})[handles[h]] || [];
      for (var p = 0; p < partners.length; p++) {
        if (!inCart[partners[p]] && available(partners[p])) {
          return {
            handle: partners[p],
            // No discount is ever auto-invented for a data-driven pick.
            rule: { discountPercent: 0, message: 'Goes great with your order' },
          };
        }
      }
    }
    return null;
  }

  window.CartComplements = { pick: pick };
})();
